import React from 'react'
import Loading from './../components/Loading'

export const loading = (props) => (
  <Loading {...props} />
)